import type { FC, ReactElement } from 'react';

import { useFeature } from '../../../services/features/reactBindings/hooks';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useHeaderSlice } from '../../../store/slices/header/selectors';
import { headerActions } from '../../../store/slices/header/slice';
import { HeaderModal } from '../../../store/slices/header/types';
import { Modal } from '../../modal/modal/Modal';
import { HelpConnected } from '../HelpConnected';
import { HelpFooterConnected } from '../HelpFooterConnected';

export const HelpModalConnected: FC = (): ReactElement => {
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const newLayout = useFeature('newLayout');
  const isOpen = openedModal === HeaderModal.Help;
  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;
  const dispatch = useCoreDispatch();

  const onClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
  };

  return (
    <Modal
      data-testid="help-modal"
      draggable
      footer={<HelpFooterConnected />}
      fullScreenNoClose
      grow
      heightAdjustment={heightAdjustment}
      newLayout={newLayout}
      onClose={onClose}
      open={isOpen}
      originX="end"
      tk="HELP"
    >
      <HelpConnected />
    </Modal>
  );
};
